module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "toc_title"
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454925767_epub_itr_r1"
    }
  }, [_vm._v("INTRODUCTION: ALL THAT GLITTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "toc_part"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454925767_epub_p01_r1"
    }
  }, [_c('strong', [_vm._v("PART I: PEOPLE AND THINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/v.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c01_r1"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 1")])]), _c('br'), _vm._v("Centennial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 2")])]), _c('br'), _vm._v("The Dynamo, the Virgin, and the Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 3")])]), _c('br'), _vm._v("Titans, Plutocrats, and Philanthropists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 4")])]), _c('br'), _vm._v("Science and Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 5")])]), _c('br'), _vm._v("The Marketplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 6")])]), _c('br'), _vm._v("Statue and Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 7")])]), _c('br'), _vm._v("Hard Labor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 8")])]), _c('br'), _vm._v("Gilded Monuments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 9")])]), _c('br'), _vm._v("American Realism")])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "toc_part"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART II: FORM AND REFORM")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/v.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 10")])]), _c('br'), _vm._v("Reconstruction Ends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 11")])]), _c('br'), _vm._v("A Woman’s Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 12")])]), _c('br'), _vm._v("The Frontier Closes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 13")])]), _c('br'), _vm._v("Dirty Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 14")])]), _c('br'), _vm._v("The Progressives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_small"
  }, [_c('strong', [_vm._v("CHAPTER 15")])]), _c('br'), _vm._v("White City")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_bm"
  }, [_c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOURCE NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FURTHER READING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454925767_epub_cre_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMAGE CREDITS")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d57812a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454925767_epub_toc_r1.vue
// module id = 63
// module chunks = 0